import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & {
  color?: string;
  size?: number;
};
const SvgClockIcon = ({ color, size = 40, ...props }: Props) => {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="svg-wrapper"
      transform={`scale(${size / 40})`}
      style={{ WebkitTransform: `scale(${size / 40})` }}
      {...props}
    >
      <path
        d="M20 4C11.161 4 4 11.161 4 20s7.161 16 16 16 16-7.161 16-16S28.839 4 20 4Zm6.108 17.076-5.518 2.337a.483.483 0 0 1-.451-.046l-1.516-1.007a.483.483 0 0 1-.208-.393v-9.695a.47.47 0 0 1 .474-.475h2.21a.47.47 0 0 1 .474.475v7.3l3.31-1.412a.476.476 0 0 1 .624.255l.856 2.048a.476.476 0 0 1-.255.624v-.011Z"
        fill={color || "#595959"}
      />
    </svg>
  );
};
export default SvgClockIcon;
